import { To } from 'react-router-dom';

export const removeLanguagePrefix = (pathname: string, lang?: string) => {
  if (!lang) {
    return pathname;
  }

  if (pathname.startsWith('/' + lang)) {
    return pathname.slice(lang.length + 1);
  }

  return pathname;
};

/**
 * Resolve to with language prefix
 */
export const localizedResolveTo = (to: To, currentLang?: string, newLang?: string | null): To => {
  const targetLang = newLang === undefined ? currentLang : newLang;

  if (targetLang === undefined) {
    return to;
  }

  const prefix = targetLang ? `/${targetLang}` : '';

  if (typeof to === 'object') {
    if (to.pathname && to.pathname.startsWith('/')) {
      to.pathname = `${prefix}${removeLanguagePrefix(to.pathname, currentLang)}`;
    }
  } else if (typeof to === 'string') {
    if (to.startsWith('/')) {
      to = `${prefix}${removeLanguagePrefix(to, currentLang)}`;
    }
  }

  return to;
};
